import { PaginationOptions } from "../../common/types/Pagination";
import { SortingOptions } from "../../common/types/Sorting";

export const possibleAnswers: Answer[] = [
  { value: 1, label: "Slaba" },
  { value: 2, label: "Echitabila" },
  { value: 3, label: "Buna" },
  { value: 4, label: "Foarte Buna" },
  { value: 5, label: "Excelenta" },
];

export interface Answer {
  value: number;
  label: string;
  description?: string;
}

export interface Feedback {
  id: string;
  departmentId: string;
  ticketId: string;
  prettyTicketId: string;
  userId: string;
  userName: string;
  agentId: string;
  agentName: string;
  question: string;
  answer?: Answer;
  createdPretty: string;
}

export interface SearchFeedbacksFilter extends PaginationOptions, SortingOptions {
  departmentId?: string;
  ticketId?: string;
  answerValue?: string;
  agentId?: string;
}
